import { local, session } from "@/utils/storage.js";
import { authRoutes } from "@/router/routes.js";
import auth from "@/api/auth.js";
import { cloneDeep } from "lodash-es";

export default async function (router) {
  // 账户的type值 -1=超级管理员 0=管理员 1=用户
  const type = local.get("type");
  await processAuthRoutes(router, type);
  await processAuthRoutesLocal(router, type);
}

// 处理后端返回的动态路由
async function processAuthRoutes(router, type) {
  // 管理员和超管有所有菜单权限
  if (type === -1 || type === 0) {
    session.set("routes", authRoutes);
    authRoutes.forEach((route) => {
      router.addRoute("admin", route);
    });
  } else {
    // 用户拥有的角色
    const roles = local.get("roles");
    if (!roles) return;
    console.log(roles,"角色")
    // 获取用户角色菜单权限列表
    let res = await auth.getRolePermissionList(roles).catch(err => null);
     console.log(res,"菜单权限")
    if(!res || !res.data) return;
    const permissionRoutes = res.data;

    // ==============================================
    // 核心：把后端权限列表转成 路径Set，方便快速匹配
    // ==============================================
    const permissionPathSet = new Set(
      permissionRoutes.map(item => item.path) 
    );

    // ==============================================
    // 递归过滤：保留本地顺序，只保留有权限的路由
    // ==============================================
    function filterRoutesByPermission(routes) {
      return routes.filter(route => {
        // 判断当前路由是否有权限
        const hasPermission = permissionPathSet.has(route.path);
        
        // 如果有子路由，递归过滤（保持本地顺序）
        if (hasPermission && route.children && route.children.length) {
          route.children = filterRoutesByPermission(route.children);
        }
        
        return hasPermission;
      });
    }

    // ==============================================
    // 最终路由：本地顺序 ✅ 只保留有权限的 ✅
    // ==============================================
    const filteredRoutes = filterRoutesByPermission(cloneDeep(authRoutes));

    // 存储并添加路由
    session.set("routes", filteredRoutes);
    filteredRoutes.forEach((route) => {
      router.addRoute("admin", route);
    });
  }
}
// 处理本地动态路由(菜单列表、角色列表、用户列表等)
async function processAuthRoutesLocal(router, type) {
  //  console.log(router,type,'处理本地动态路由(菜单列表、角色列表、用户列表等)')
  const authRoutes_local = {
    // 角色权限
    role: {
      path: "/set/role",
      name: "role",
      component: () => import("@/view/admin/set/role/index.vue"),
      meta: {
        title: "角色权限",
      },
    },
    // 海康测评人员
    // hikvisionEvaluationPersonnel: {
    //   path: "/set/hikvisionEvaluationPersonnel",
    //   name: "hikvisionEvaluationPersonnel",
    //   component: () => import("@/view/admin/set/hikvisionEvaluationPersonnel/index.vue"),
    //   meta: {
    //     title: "海康测评人员",
    //   },
    // },
    //经销商
    agency: {
      path: "/set/agency",
      name: "agency",
      component: () => import("@/view/admin/set/agency/index.vue"),
      meta: {
        title: "经销商管理",
      },
    },
    //部门管理
    department: {
      path: "/set/departmentMaintenance",
      name: "departmentMaintenance",
      component: () => import("@/view/admin/set/departmentMaintenance/index.vue"),
      meta: {
        title: "部门管理",
      },
    },
    // 菜单维护
    menu: {
      path: "/set/menuMaintenance",
      name: "menuMaintenance",
      component: () => import("@/view/admin/set/menuMaintenance/index.vue"),
      meta: {
        title: "菜单维护",
      },
    },
    // 权限
    permission: {
      path: "/set/permission",
      name: "permission",
      component: () => import("@/view/admin/set/permission/index.vue"),
      meta: {
        title: "权限设置",
      },
    },
    // 字典
    dict: {
      path: "/set/dict",
      name: "dict",
      component: () => import("@/view/admin/set/dict/index.vue"),
      meta: {
        title: "字典维护",
      },
    },
    // 组织管理
    origination: {
      path: "/set/origination",
      name: "origination",
      component: () => import("@/view/admin/set/origination/index.vue"),
      meta: {
        title: "组织管理",
      },
    },
    // 预警规则管理
    warningRule: {
      path: "/set/warningRule",
      name: "warningRule",
      component: () => import("@/view/admin/set/warningRule/index.vue"),
      meta: {
        title: "预警规则管理",
      },
    },
    // 新增预警规则
    warningRuleAdd: {
      path: "/set/warningRule/add",
      name: "warningRuleAdd",
      component: () => import("@/view/admin/set/warningRule/add.vue"),
      meta: {
        title: "新增预警规则",
      },
    },
    // 预警规则详情
    warningRuleDetail: {
      path: "/set/warningRule/detail",
      name: "warningRuleDetail",
      component: () => import("@/view/admin/set/warningRule/detail.vue"),
      meta: {
        title: "预警规则详情",
      },
    },
    // 通道管理
    channelManagement: {
      path: "/set/channelManagement",
      name: "channelManagement",
      component: () => import("@/view/admin/set/channelManagement/index.vue"),
      meta: {
        title: "通道管理",
      },
    },
  };
  const { role,agency, menu, permission, dict, origination, warningRule,department,channelManagement } = authRoutes_local;
  const typeRoutes = {
    "-1": [role,agency,department, menu, permission, dict, origination, warningRule,channelManagement],
    0: [role, agency,department, permission,dict, warningRule,channelManagement],
  };

  let routes = typeRoutes[type] || [];
  if (routes.length) {
    const route = {
      path: "/set",
      name: "set",
      component: () => import("@/view/admin/set/index.vue"),
      meta: {
        title: "系统设置",
        icon: "xitongshezhi",
      },
      children: routes,
    };
    await router.addRoute("admin", route);
    const routesMenu = session.get("routes");
    routesMenu.push(route);
    session.set("routes", routesMenu);
  }

  // 添加新增预警规则和详情路由（不在菜单中显示）
  if (type === "-1" || type === 0) {
    await router.addRoute("admin", authRoutes_local.warningRuleAdd);
    await router.addRoute("admin", authRoutes_local.warningRuleDetail);
  }

  // 添加工单详情路由（不在菜单中显示）
    await router.addRoute("admin", {
      path: "/warningWorkOrder/detail/:id",
      name: "warningWorkOrderDetail",
      component: () => import("@/view/admin/warningWorkOrder/detail.vue"),
      meta: {
        title: "工单详情",
      },
    });
   // 测评历史详情路由（不在菜单中显示）
    await router.addRoute("admin", {
      path: "/testHistory/details",
      name: "testHistoryDetails",
      component: () => import("@/view/admin/testHistory/details.vue"),
      meta: {
        title: "报告详情",
      },
    });
    // 评测人员详情路由（不在菜单中显示）
    await router.addRoute("admin", {
      path: "/userManagement/details",
      name: "userManagementDetails",
      component: () => import("@/view/admin/userManagement/details.vue"),
      meta: {
        title: "趋势详情",
      },
    });
}
